import { useEffect } from "react";
import LastTrades from "../components/LastTrades";
import MarketChanges from "../components/MarketChanges";
import OrdersBook from "../components/orderbox/OrdersBook";
import OrdersHistory from "../components/orders-history/OrdersHistory";
import OrdersPercentage from "../components/OrdersPercentage";
import Pairs from "../components/pairbox/Pairs";
import TradingComp from "../components/tradespot/TradingComp";
import TradingChart from "../components/TradingChart";
import { useMainContext } from "../contexts/main";
import { useWindowSize } from "../hooks/common/useWindowSize";
import MainLayout from "../layouts/MainLayout";
import { CFlexCenter, FlexCenter, Padding } from "../styles/CommonStyles";
import {MOBILE_SIZE, TABLET_SIZE} from "../constants/common";
import RMarketChanges from "../components/responsive/RMarketChanges";
import RTradingComp from "../components/responsive/RTradingComp";
import {useParams} from "react-router-dom";
import {GridItem, DigiMinexGridLayout} from "../styles/TradeStyles";
import {Market} from "../styles/OrdersStyle";


const TradeDashboard = () => {

    const params = useParams()
    const { market, setMarket } = useMainContext()
    const { width } = useWindowSize()

    useEffect(() => {
        if (params.id?.includes("_")) {
            const coins = params.id.split('_')
            if (coins.length > 1){
                const coin = coins[0].toLowerCase();
                const pair = coins[1].toLowerCase();
                setMarket({coin, pair})
            }
        }
    }, [])

    // /* url modification */
    useEffect(() => {
        window.history.replaceState(
            {}, null, `/trade/${market.coin?.toUpperCase()}_${market.pair?.toUpperCase()}`
        )
    }, [market])

    const gridItems = {
        a: MarketChanges,
        b: OrdersPercentage,
        c: TradingChart,
        d: Pairs,
        e: TradingComp,
        f: OrdersBook,
        g: LastTrades,
        x: OrdersHistory
    }

    return (
        <MainLayout>
            {width > TABLET_SIZE &&
                <DigiMinexGridLayout>
                    { Object.keys(gridItems).map(key => {
                        const Comp = gridItems[key]

                        return (
                            <GridItem area={key}>
                                <Comp />
                            </GridItem>
                        )
                    })}
                </DigiMinexGridLayout>
            }
            {
                (width > MOBILE_SIZE && width <= TABLET_SIZE) &&
                <>
                    <MarketChanges />
                    <FlexCenter>
                        <Padding padding="0 0 4px 0">
                            <TradingComp />
                            <CFlexCenter width="70%">
                                <TradingChart />
                                <FlexCenter >
                                    <OrdersBook />
                                    <LastTrades />
                                </FlexCenter>
                                <OrdersHistory />
                            </CFlexCenter>
                        </Padding>
                    </FlexCenter>
                </>
            }
            {width <= MOBILE_SIZE &&
                <>
                    <RMarketChanges />
                    <FlexCenter style={{ alignItems: "stretch" }}>
                        <FlexCenter width="50%" height="unset">
                            <RTradingComp />
                        </FlexCenter>
                        <FlexCenter width="50%" height="unset">
                            <OrdersBook />
                        </FlexCenter>
                    </FlexCenter>
                    <FlexCenter>
                        <OrdersHistory />
                    </FlexCenter>
                    <FlexCenter>
                        <TradingChart />
                    </FlexCenter>
                </>
            }
        </MainLayout >
    )
}


export default TradeDashboard;
